export default __webpack_public_path__ + "2ef28cb44ab0f28b3b6dc84863c28ff1.png";